import React from 'react'
import Example from '../components/ImageSlider'

function Projects() {
    return (
        <div>
            {/* <Carousel /> */}
            {/* <Example /> */}
        </div>
    )
}

export default Projects
